export default {
  format: function(value) {
    let result = '',
      snNumbers = '',
      parsedValue = null;

    if (value) {
      parsedValue = value.match(/\d+/g);

      if (parsedValue) {
        if (parsedValue.length) {
          parsedValue = parsedValue.join('');
        }

        if (parsedValue.length > 10 && ['7', '8'].indexOf(parsedValue.substring(0, 1)) !== -1) {
          parsedValue = parsedValue.substring(1);
        }

        snNumbers = `${parsedValue.substring(3, 6)}-${parsedValue.substring(6, 8)}-${parsedValue.substring(8, 10)}`;
        result = `+998 (${parsedValue.substring(0, 2)}) ${snNumbers}`;

        if (parsedValue.length > 10) {
          result = `${result} #${parsedValue.substring(10)}`
        }
      }
    }

    return result;
  }
}
